import type {TvmByAlias} from '../../types'
import {PRODUCTION} from './production'
import {TESTING} from './testing'

export const VIRT = {
  production: PRODUCTION,
  testing: TESTING,
} as const satisfies TvmByAlias
